import { Settings } from './settings';

const servicesConfig = window['servicesConfig'];

//TODO - move this into a new service
export let AppSettings: Settings = null;

function init(): void {
    if (!AppSettings) {
        AppSettings = new Settings();
        for (const key in AppSettings) {
            if (servicesConfig) {
                if (!servicesConfig[key]) {
                    console.warn('Setting %s not found in services.config.js', key);
                }
            }
        }
        AppSettings = servicesConfig as Settings;
    }
}

init();
